import {AnchoredOverlay, Button} from '@primer/react'
import type {RefObject} from 'react'
import {useState} from 'react'
import {useDismissOrgNotice} from '../hooks/use-org-notices'

export function DemoNotification({
  anchorRef,
  repoName,
  orgName,
  ownerId,
}: {
  anchorRef: RefObject<HTMLElement | null>
  repoName: string
  orgName: string
  ownerId: string
}) {
  const [isOpen, setIsOpen] = useState(true)
  const {dismissNotice} = useDismissOrgNotice('demo_repository_notification', orgName, ownerId)

  return (
    <AnchoredOverlay
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      renderAnchor={null}
      anchorRef={anchorRef}
      overlayProps={{role: 'dialog', 'aria-label': 'Demo notification'}}
      side="outside-bottom"
      align="start"
      alignmentOffset={20}
      width="medium"
      height="fit-content"
    >
      <div className="p-4">
        <h4 className="mb-1">Welcome to your demo repository</h4>
        <p className="mb-0 color-fg-muted">
          To help you get started, we&apos;ve created a code repository in your organization, named{' '}
          <strong>{repoName}</strong>. You can use it to sample some of GitHub&apos;s most valuable tools.
        </p>

        <Button
          className="mt-3"
          onClick={() => {
            setIsOpen(false)
            dismissNotice()
          }}
        >
          Got it!
        </Button>
      </div>
    </AnchoredOverlay>
  )
}
